'use strict';

import {element_exists} from "../functions";

export var fnCustomerEmployeesPostalCodes = function () {

    var formParentDiv = '#form-setup-employees';

    if (!element_exists(formParentDiv)) {
        return false;
    }

    var postalCodeElement = $('input[name="address[main][postal_code]"]');
    var cityElement = $('input[name="address[main][city]"]');

    var selectElement = function (e) {
        postalCodeElement.val($(this).attr('data-code'));
        cityElement.val($(this).attr('data-name'));
    };

    var postalCodeSuggestion = postalCodeElement.suggestionBox({
        filter: true,
        heading: '',
        enterKeyAction: selectElement,
        selectElement: selectElement,
        element_id: 'postal-code-auto-suggest',
    }).loadSuggestions("/postal-codes/search");

    var citySuggestion = cityElement.suggestionBox({
        filter: true,
        element_id: 'city-auto-suggest',
        enterKeyAction: selectElement,
        heading: '',
        selectElement: selectElement
    }).loadSuggestions("/postal-codes/search");

    $('#form-setup-employees .address-tab').on('show.bs.tab', function () {
        setTimeout(function () {
            postalCodeSuggestion.setSuggestionBoxPosition();
            citySuggestion.setSuggestionBoxPosition();
        }, 20);
    });
};